import { TransitionType } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Animations/Transitions/Transitions.types';
import { IconName } from '@/components/atoms/Icon';

export const TransitionIconMap: Record<TransitionType, IconName> = {
  [TransitionType.FADE]: 'IconWashDryShade',
  [TransitionType.DROP]: 'IconTransitionDrop',
  [TransitionType.MOVE]: 'IconArrowsMove',
  [TransitionType.ROTATE]: 'IconRotateClockwise2',
  [TransitionType.SCALE]: 'IconArrowsMaximize'
};
